import React from 'react';
import Skeleton from 'components/general/Skeleton/Skeleton';
import getSkeletonItems from 'utils/genSkeletonItems';

const skeletonSummaries = getSkeletonItems(3, 'media');

const MediaSkeleton: React.SFC<PropDef> = ({ image }) => (
  <div className="media media--skeleton">
    {image && (
      <div className="media__image">
        <Skeleton types={['image']} />
      </div>
    )}
    <div className="media__content">
      <div className="media__category">
        <Skeleton width={[100, 120]} />
      </div>
      <div className="media__title">
        <Skeleton width={[150, 200]} />
      </div>
      <div className="media__summary">
        {skeletonSummaries.map(({ id }) => <Skeleton key={id} />)}
        <Skeleton width={[300, 450]} unit="%" />
      </div>
      <div className="media__footer">
        <div className="media__meta">
          <Skeleton width={[80, 120]} />
        </div>
      </div>
    </div>
  </div>
);

MediaSkeleton.defaultProps = {
  image: true,
};

interface PropDef {
  image?: boolean;
}

export default MediaSkeleton;

